import { Icon } from '@chakra-ui/react';

export const RefreshIcon = () => (
    <Icon viewBox="0 0 24 24">
        <path
            fill="none"
            stroke="currentColor"
            d="M2 10C2 10 2.12132 9.15076 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.364 5.63604C19.6092 6.88131 20.4133 8.40072 20.7762 10M2 10V4M2 10H8M22 14C22 14 21.8787 14.8492 18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C4.39076 17.1187 3.58669 15.5993 3.22383 14M22 14V20M22 14H16"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const TrashIcon = () => (
    <Icon viewBox="0 0 24 24">
        <path
            fill="none"
            stroke="currentColor"
            d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const CheckIcon = () => (
    <Icon viewBox="0 0 16 12">
        <path
            fill="none"
            stroke="#060D2F"
            d="M1.6084 6.51623L5.54197 10.4498L5.51656 10.4244L14.3911 1.5498"
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const EyeIcon = () => (
    <Icon viewBox="0 0 24 24">
        <path
            fill="none"
            d="M12.0001 18.9999C11.1581 18.9999 10.3151 18.8219 9.49609 18.5049"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M20.882 12.4678C18.99 15.9668 15.495 18.9998 12 18.9998"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M19.0791 8.9209C19.7701 9.7299 20.3841 10.6119 20.8821 11.5329C21.0391 11.8239 21.0391 12.1769 20.8821 12.4679"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M5 19L19 5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M9.77309 14.2271C8.54309 12.9971 8.54309 11.0021 9.77309 9.77211C11.0031 8.54211 12.9981 8.54211 14.2281 9.77211"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M17.0438 6.956C15.4968 5.759 13.7478 5 11.9998 5C8.50475 5 5.00975 8.033 3.11775 11.533C2.96075 11.824 2.96075 12.177 3.11775 12.468C4.06375 14.217 5.40975 15.849 6.95575 17.045"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const ChevronDownIcon = ({ w = '24px', h = '24px' }) => (
    <Icon viewBox="0 0 24 24" w={w} h={h}>
        <path
            d="M6 9L12 15L18 9"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const CheckmarkCircleIcon = () => (
    <Icon viewBox="0 0 24 24" w="24px" h="24px">
        <path
            fill="none"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M8.44434 12.3385L10.6113 14.5055L10.5973 14.4915L15.4863 9.60254"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const BackIcon = () => (
    <Icon viewBox="0 0 24 24" w="24px" h="24px">
        <path
            d="M12 8.70898L8 12.709M8 12.709L12 16.709M8 12.709H16M7.8 21.709H16.2C17.8802 21.709 18.7202 21.709 19.362 21.382C19.9265 21.0944 20.3854 20.6354 20.673 20.071C21 19.4292 21 18.5891 21 16.909V8.50898C21 6.82883 21 5.98875 20.673 5.34701C20.3854 4.78253 19.9265 4.32358 19.362 4.03596C18.7202 3.70898 17.8802 3.70898 16.2 3.70898H7.8C6.11984 3.70898 5.27976 3.70898 4.63803 4.03596C4.07354 4.32358 3.6146 4.78253 3.32698 5.34701C3 5.98875 3 6.82883 3 8.50898V16.909C3 18.5891 3 19.4292 3.32698 20.071C3.6146 20.6354 4.07354 21.0944 4.63803 21.382C5.27976 21.709 6.11984 21.709 7.8 21.709Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const MMAIcon = () => (
    <Icon viewBox="0 0 24 24" w="24px" h="24px">
        <path
            fill="none"
            d="M15.5898 14.3833L15.8558 13.9833C16.4011 13.1658 17.2001 12.5503 18.1296 12.2315C19.0591 11.9128 20.0676 11.9085 20.9998 12.2193"
            stroke="#060D2F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M10.0651 12.7929L11.2651 6.80894L12.5751 7.46394C12.8103 7.58134 13.0801 7.60914 13.3342 7.54216C13.5883 7.47517 13.8094 7.31799 13.9561 7.09994L15.1001 5.38294C15.2386 5.1748 15.3009 4.92515 15.2763 4.67635C15.2517 4.42754 15.1417 4.19492 14.9651 4.01794L13.5251 2.57794C13.203 2.25572 12.772 2.06558 12.3168 2.04486C11.8617 2.02414 11.4152 2.17433 11.0651 2.46594C7.65798 5.30495 5.10991 9.03772 3.70713 13.2449L3.10713 15.0309C2.96133 15.4705 2.96037 15.9451 3.10437 16.3852C3.24836 16.8253 3.52974 17.2076 3.90713 17.4759L5.43813 18.5699C6.89203 19.6087 8.58381 20.2651 10.3578 20.4788C12.1319 20.6926 13.9311 20.4567 15.5901 19.7929L16.6721 21.9569"
            stroke="#060D2F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fill="none"
            d="M15.5897 13.3C14.6283 12.6593 13.4989 12.3174 12.3437 12.3174C11.1884 12.3174 10.059 12.6593 9.09766 13.3"
            stroke="#060D2F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const ArrowRightIcon = () => (
    <Icon viewBox="0 0 12 12" w="12px" h="12px">
        <path
            d="M2.5 6L9.5 6M9.5 6L6 2.5M9.5 6L6 9.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
export const AlertErrorIcon = () => (
    <Icon viewBox="0 0 64 64" w="64px" h="64px">
        <path
            d="M41.415 25.415L34.8275 32L41.415 38.585C41.6008 38.7708 41.7482 38.9914 41.8488 39.2342C41.9494 39.477 42.0011 39.7372 42.0011 40C42.0011 40.2628 41.9494 40.523 41.8488 40.7658C41.7482 41.0086 41.6008 41.2292 41.415 41.415C41.2292 41.6008 41.0086 41.7482 40.7658 41.8488C40.523 41.9494 40.2628 42.0011 40 42.0011C39.7372 42.0011 39.477 41.9494 39.2342 41.8488C38.9914 41.7482 38.7708 41.6008 38.585 41.415L32 34.8275L25.415 41.415C25.2292 41.6008 25.0086 41.7482 24.7658 41.8488C24.523 41.9494 24.2628 42.0011 24 42.0011C23.7372 42.0011 23.477 41.9494 23.2342 41.8488C22.9914 41.7482 22.7708 41.6008 22.585 41.415C22.3992 41.2292 22.2518 41.0086 22.1512 40.7658C22.0507 40.523 21.9989 40.2628 21.9989 40C21.9989 39.7372 22.0507 39.477 22.1512 39.2342C22.2518 38.9914 22.3992 38.7708 22.585 38.585L29.1725 32L22.585 25.415C22.2097 25.0397 21.9989 24.5307 21.9989 24C21.9989 23.4693 22.2097 22.9603 22.585 22.585C22.9603 22.2097 23.4693 21.9989 24 21.9989C24.5307 21.9989 25.0397 22.2097 25.415 22.585L32 29.1725L38.585 22.585C38.7708 22.3992 38.9914 22.2518 39.2342 22.1512C39.477 22.0506 39.7372 21.9989 40 21.9989C40.2628 21.9989 40.523 22.0506 40.7658 22.1512C41.0086 22.2518 41.2292 22.3992 41.415 22.585C41.6008 22.7708 41.7482 22.9914 41.8488 23.2342C41.9494 23.477 42.0011 23.7372 42.0011 24C42.0011 24.2628 41.9494 24.523 41.8488 24.7658C41.7482 25.0086 41.6008 25.2292 41.415 25.415ZM58 32C58 37.1423 56.4751 42.1691 53.6182 46.4448C50.7613 50.7205 46.7007 54.053 41.9498 56.0209C37.1989 57.9887 31.9712 58.5036 26.9277 57.5004C21.8842 56.4972 17.2514 54.0209 13.6152 50.3848C9.97907 46.7486 7.50281 42.1159 6.49959 37.0723C5.49638 32.0288 6.01127 26.8011 7.97914 22.0502C9.94702 17.2994 13.2795 13.2387 17.5552 10.3818C21.8309 7.52487 26.8577 6 32 6C38.8934 6.00728 45.5024 8.74889 50.3767 13.6233C55.2511 18.4976 57.9927 25.1066 58 32ZM54 32C54 27.6488 52.7097 23.3953 50.2923 19.7775C47.875 16.1596 44.439 13.3398 40.419 11.6747C36.3991 10.0095 31.9756 9.57385 27.708 10.4227C23.4404 11.2716 19.5204 13.3669 16.4437 16.4437C13.3669 19.5204 11.2716 23.4404 10.4227 27.708C9.57386 31.9756 10.0095 36.3991 11.6747 40.419C13.3398 44.439 16.1596 47.8749 19.7775 50.2923C23.3953 52.7097 27.6488 54 32 54C37.8327 53.9934 43.4247 51.6734 47.5491 47.549C51.6734 43.4247 53.9934 37.8327 54 32Z"
            fill="currentColor"
        />
    </Icon>
);
export const AlertInfoIcon = () => (
    <Icon viewBox="0 0 64 64" w="64px" h="64px">
        <path
            d="M32 6C26.8577 6 21.8309 7.52487 17.5552 10.3818C13.2795 13.2387 9.94702 17.2994 7.97914 22.0502C6.01127 26.8011 5.49638 32.0288 6.49959 37.0723C7.50281 42.1159 9.97907 46.7486 13.6152 50.3848C17.2514 54.0209 21.8842 56.4972 26.9277 57.5004C31.9712 58.5036 37.1989 57.9887 41.9498 56.0209C46.7007 54.053 50.7613 50.7205 53.6182 46.4448C56.4751 42.1691 58 37.1423 58 32C57.9927 25.1066 55.2511 18.4976 50.3767 13.6233C45.5024 8.74889 38.8934 6.00728 32 6ZM32 54C27.6488 54 23.3953 52.7097 19.7775 50.2923C16.1596 47.8749 13.3398 44.439 11.6747 40.419C10.0095 36.3991 9.57386 31.9756 10.4227 27.708C11.2716 23.4404 13.3669 19.5204 16.4437 16.4437C19.5204 13.3669 23.4404 11.2716 27.708 10.4227C31.9756 9.57385 36.3991 10.0095 40.419 11.6747C44.439 13.3398 47.875 16.1596 50.2923 19.7775C52.7097 23.3953 54 27.6488 54 32C53.9934 37.8327 51.6734 43.4247 47.5491 47.549C43.4247 51.6734 37.8327 53.9934 32 54ZM36 44C36 44.5304 35.7893 45.0391 35.4142 45.4142C35.0392 45.7893 34.5304 46 34 46C32.9391 46 31.9217 45.5786 31.1716 44.8284C30.4214 44.0783 30 43.0609 30 42V32C29.4696 32 28.9609 31.7893 28.5858 31.4142C28.2107 31.0391 28 30.5304 28 30C28 29.4696 28.2107 28.9609 28.5858 28.5858C28.9609 28.2107 29.4696 28 30 28C31.0609 28 32.0783 28.4214 32.8284 29.1716C33.5786 29.9217 34 30.9391 34 32V42C34.5304 42 35.0392 42.2107 35.4142 42.5858C35.7893 42.9609 36 43.4696 36 44ZM28 21C28 20.4067 28.176 19.8266 28.5056 19.3333C28.8352 18.8399 29.3038 18.4554 29.852 18.2284C30.4001 18.0013 31.0033 17.9419 31.5853 18.0576C32.1672 18.1734 32.7018 18.4591 33.1213 18.8787C33.5409 19.2982 33.8266 19.8328 33.9424 20.4147C34.0581 20.9967 33.9987 21.5999 33.7716 22.1481C33.5446 22.6962 33.1601 23.1648 32.6667 23.4944C32.1734 23.8241 31.5934 24 31 24C30.2044 24 29.4413 23.6839 28.8787 23.1213C28.3161 22.5587 28 21.7956 28 21Z"
            fill="currentColor"
        />
    </Icon>
);
export const AlertWarningIcon = () => (
    <Icon viewBox="0 0 64 64" w="64px" h="64px">
        <path
            d="M32 6C26.8577 6 21.8309 7.52487 17.5552 10.3818C13.2795 13.2387 9.94702 17.2994 7.97914 22.0502C6.01127 26.8011 5.49638 32.0288 6.49959 37.0723C7.50281 42.1159 9.97907 46.7486 13.6152 50.3848C17.2514 54.0209 21.8842 56.4972 26.9277 57.5004C31.9712 58.5036 37.1989 57.9887 41.9498 56.0209C46.7007 54.053 50.7613 50.7205 53.6182 46.4448C56.4751 42.1691 58 37.1423 58 32C57.9927 25.1066 55.2511 18.4976 50.3767 13.6233C45.5024 8.74889 38.8934 6.00728 32 6ZM32 54C27.6488 54 23.3953 52.7097 19.7775 50.2923C16.1596 47.8749 13.3398 44.439 11.6747 40.419C10.0095 36.3991 9.57386 31.9756 10.4227 27.708C11.2716 23.4404 13.3669 19.5204 16.4437 16.4437C19.5204 13.3669 23.4404 11.2716 27.708 10.4227C31.9756 9.57385 36.3991 10.0095 40.419 11.6747C44.439 13.3398 47.875 16.1596 50.2923 19.7775C52.7097 23.3953 54 27.6488 54 32C53.9934 37.8327 51.6734 43.4247 47.5491 47.549C43.4247 51.6734 37.8327 53.9934 32 54ZM30 34V20C30 19.4696 30.2107 18.9609 30.5858 18.5858C30.9609 18.2107 31.4696 18 32 18C32.5304 18 33.0392 18.2107 33.4142 18.5858C33.7893 18.9609 34 19.4696 34 20V34C34 34.5304 33.7893 35.0391 33.4142 35.4142C33.0392 35.7893 32.5304 36 32 36C31.4696 36 30.9609 35.7893 30.5858 35.4142C30.2107 35.0391 30 34.5304 30 34ZM35 43C35 43.5933 34.8241 44.1734 34.4944 44.6667C34.1648 45.1601 33.6962 45.5446 33.1481 45.7716C32.5999 45.9987 31.9967 46.0581 31.4147 45.9424C30.8328 45.8266 30.2982 45.5409 29.8787 45.1213C29.4591 44.7018 29.1734 44.1672 29.0577 43.5853C28.9419 43.0033 29.0013 42.4001 29.2284 41.852C29.4554 41.3038 29.84 40.8352 30.3333 40.5056C30.8266 40.1759 31.4067 40 32 40C32.7957 40 33.5587 40.3161 34.1213 40.8787C34.6839 41.4413 35 42.2043 35 43Z"
            fill="currentColor"
        />
    </Icon>
);

export const AutoIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M22.0009 9L19.3809 10"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.63 10L2 9"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M18.25 14H15.75"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.25 14H5.75"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19.379 10L18.54 5.988C18.297 4.83 17.276 4 16.092 4H8.01195C6.85095 4 5.84195 4.8 5.57795 5.931L4.62695 10"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.25 20H5.5C6.328 20 7 19.328 7 18.5V17.5H17V18.5C17 19.328 17.672 20 18.5 20H20.75C21.44 20 22 19.44 22 18.75V13C22 11.343 20.657 10 19 10H5C3.343 10 2 11.343 2 13V18.75C2 19.44 2.56 20 3.25 20Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);

export const BaseballIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M21.2603 14.5837C22.1089 15.4323 22.1089 16.8082 21.2603 17.6568C20.4117 18.5054 19.0358 18.5054 18.1872 17.6568C17.3386 16.8082 17.3386 15.4323 18.1872 14.5837C19.0358 13.7351 20.4117 13.7351 21.2603 14.5837Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.93106 16.0344L6.63206 19.3334L6.74006 19.4414C7.26606 19.9674 7.26606 20.8214 6.74006 21.3474C6.21406 21.8734 5.36006 21.8734 4.83406 21.3474L2.49606 19.0104C1.97006 18.4844 1.97006 17.6304 2.49606 17.1044C3.02206 16.5784 3.87606 16.5784 4.40206 17.1044L4.51006 17.2124L7.80906 13.9134L8.64306 12.6794C10.9911 9.20538 13.6651 5.96438 16.6301 3.00038C17.6881 1.94238 19.4891 2.02838 20.6521 3.19138C21.8151 4.35438 21.9011 6.15538 20.8431 7.21338C17.8791 10.1774 14.6381 12.8524 11.1641 15.2004L9.93106 16.0344Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.92859 16.0302L7.80859 13.9102"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const BasketballIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M5.64062 5.64062L18.3606 18.3606"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 3C12 7.971 7.971 12 3 12"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 21C12 16.029 16.029 12 21 12"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.64062 18.3606L18.3606 5.64062"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const BoxingIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M7.58594 8.63477C8.07996 9.12636 9.51263 10.1096 11.2911 10.1096C13.0696 10.1096 16.4783 10.1096 17.9604 10.1096"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.58594 8.63477C7.58594 13.7966 9.80905 14.5339 11.2911 14.5339"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.98779 18.3637H18.9507M7.98779 18.3637V22H18.9507V18.3637M7.98779 18.3637C4.33351 15.9394 2.50637 9.87878 3.11541 8.06061C3.60266 6.60606 5.75463 7.0505 6.7697 7.45454C6.7697 3.21212 8.59684 2 13.4692 2C18.3416 2 20.7778 3.21212 20.7778 9.27272C20.7778 14.1212 19.5597 17.3536 18.9507 18.3637"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const CricketIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M15.2414 7.5309C15.1672 7.402 15.0031 7.10903 15.0187 7.0934L19.4601 2.64809C19.6828 2.42543 20.3742 1.89809 19.4601 0.980121L19.0031 0.523089C18.1242 -0.355817 17.5578 0.300433 17.3351 0.523089L12.8937 4.9684C12.8781 4.98403 12.5851 4.81606 12.4562 4.74184C12.0265 4.49965 11.4836 4.56996 11.1359 4.91762L6.24139 9.81606C5.78436 9.29653 5.11639 8.96449 4.3742 8.96449C3.00311 8.96449 1.88983 10.0778 1.88983 11.4489C1.88983 12.195 2.22186 12.8629 2.74139 13.3161L0.237483 15.8239C0.0851396 15.9762 0.0343584 16.2067 0.112483 16.4098C0.757015 18.0622 1.92108 19.2301 3.57733 19.8746C3.64373 19.8981 3.90545 20.0075 4.16326 19.7497L15.0617 8.8434C15.4133 8.50356 15.4836 7.96059 15.2414 7.5309ZM2.98748 11.4528C2.98748 10.6872 3.60858 10.0622 4.3742 10.0622C5.13983 10.0622 5.76483 10.6872 5.76483 11.4528C5.76483 12.2184 5.14373 12.8434 4.3742 12.8434C3.60858 12.8395 2.98748 12.2184 2.98748 11.4528ZM3.65155 18.7184C2.5578 18.2145 1.77655 17.4332 1.27264 16.3395L3.75311 13.859C3.95233 13.9098 4.15936 13.9411 4.3742 13.9411C5.7453 13.9411 6.85858 12.8278 6.85858 11.4567C6.85858 11.2418 6.82733 11.0348 6.77655 10.8356L11.9133 5.69887C12.0226 5.76137 12.132 5.82778 12.2375 5.89809C12.6867 6.18715 13.2883 6.12465 13.6672 5.74575L18.1125 1.29653C18.1437 1.26528 18.1984 1.26528 18.2297 1.29653L18.6867 1.75356C18.7375 1.80434 18.7062 1.85121 18.6867 1.87075L14.2414 6.31606C13.8625 6.69496 13.8 7.29653 14.089 7.74575C14.1594 7.85121 14.2219 7.96059 14.2883 8.07387L3.65155 18.7184Z"
            fill="currentColor"
        />
    </Icon>
);
export const DartsIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.2071 10H21.4992C21.681 10 21.8484 10.0986 21.9365 10.2576C22.0246 10.4166 22.0195 10.6109 21.9232 10.765L21.1513 12L21.9232 13.235C22.0195 13.3891 22.0246 13.5834 21.9365 13.7424C21.8484 13.9014 21.681 14 21.4992 14H18.2071C18.0745 14 17.9473 13.9473 17.8535 13.8535L16 12L17.8535 10.1464C17.9473 10.0527 18.0745 10 18.2071 10V10Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14 12H16"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.7671 8.00001C13.588 5.94356 10.1639 6.00964 8.06576 8.14862C5.96766 10.2876 5.96766 13.7124 8.06576 15.8514C10.1639 17.9904 13.588 18.0564 15.7671 16"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19.4833 7.0007C17.2809 3.70447 13.1811 2.23747 9.38751 3.38821C5.59391 4.53895 3 8.0364 3 12.0007C3 15.965 5.59391 19.4624 9.38751 20.6132C13.1811 21.7639 17.2809 20.2969 19.4833 17.0007"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const ESportsIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M14.6289 16H9.37291C9.13291 16 8.90091 16.086 8.71891 16.243L5.16791 19.312C3.74691 20.54 1.56991 19.313 1.88891 17.463C2.46691 14.11 3.05391 10.703 3.63891 7.318C3.96991 5.401 5.63291 4 7.57991 4H16.4229C18.3689 4 20.0329 5.401 20.3639 7.319C20.9489 10.704 21.5359 14.111 22.1139 17.464C22.4329 19.315 20.2549 20.541 18.8349 19.313L15.2839 16.244C15.1009 16.086 14.8689 16 14.6289 16Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6 10H10"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 8V12"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.999 7.75C15.861 7.75 15.749 7.862 15.75 8C15.75 8.138 15.862 8.25 16 8.25C16.138 8.25 16.25 8.138 16.25 8C16.25 7.862 16.138 7.75 15.999 7.75Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M17.999 9.75C17.861 9.75 17.749 9.862 17.75 10C17.75 10.138 17.862 10.25 18 10.25C18.138 10.25 18.25 10.138 18.25 10C18.25 9.862 18.138 9.75 17.999 9.75Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.999 11.75C15.861 11.75 15.749 11.862 15.75 12C15.75 12.138 15.862 12.25 16 12.25C16.138 12.25 16.25 12.138 16.25 12C16.25 11.862 16.138 11.75 15.999 11.75Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.999 9.75C13.861 9.75 13.749 9.862 13.75 10C13.75 10.138 13.862 10.25 14 10.25C14.138 10.25 14.25 10.138 14.25 10C14.25 9.862 14.138 9.75 13.999 9.75Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const FootballIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M19.7207 6.48094L19.7307 6.46094"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.8694 2.92969L14.8594 2.93969"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M21.5 11.9202V11.9102"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.5 11.9102V11.9202"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.26953 6.46094L4.27953 6.48094"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.14086 2.93969L9.13086 2.92969"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7175 5.28249C22.4275 8.99247 22.4275 15.0075 18.7175 18.7175C15.0075 22.4275 8.99243 22.4275 5.28249 18.7175C1.5725 15.0075 1.5725 8.99243 5.28249 5.28249C8.99247 1.5725 15.0075 1.5725 18.7175 5.28249Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.8906 10.7496L17.8906 10.0996"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M21.4436 12.8432L17.8926 10.0952L19.1506 5.78516"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 7.93031V5.82031"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.7111 3.28711L12.0001 5.81411L8.28906 3.28711"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.4004 15.3105L15.6404 17.0205"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.125 21.2487L15.642 17.0227L20.129 16.8867"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.10937 10.7496L6.10938 10.0996"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.55664 12.8432L6.10764 10.0952L4.84964 5.78516"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.59938 15.3105L8.35938 17.0205"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.87509 21.2487L8.35809 17.0227L3.87109 16.8867"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.0002 7.92578L15.8852 10.7488L14.4012 15.3148H9.59923L8.11523 10.7488L12.0002 7.92578Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const GolfIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.071 12.6109C22.9763 14.7588 22.9763 18.2412 19.071 20.3891C15.1658 22.537 8.83413 22.537 4.92893 20.3891C1.02369 18.2412 1.02369 14.7588 4.92893 12.6109C8.83417 10.463 15.1658 10.463 19.071 12.6109Z"
            stroke="currentColor"
            stroke-width="1.5119"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.98047 2V16"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.97 16H7"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 7.906L14.469 4.953L8 2"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M17.1857 15.4393C17.7714 16.0251 17.7714 16.9749 17.1857 17.5607C16.5999 18.1464 15.6501 18.1464 15.0643 17.5607C14.4786 16.9749 14.4786 16.0251 15.0643 15.4393C15.6501 14.8536 16.5999 14.8536 17.1857 15.4393Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const HockeyIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M18.6428 16.4406H12.5198C12.1518 16.4406 11.8138 16.2386 11.6398 15.9146L5.41982 4.37464C5.02182 3.63664 4.10982 3.34764 3.35882 3.72264C2.57382 4.11564 2.26982 5.07964 2.68782 5.85164L10.0228 19.3926C10.3728 20.0376 11.0478 20.4396 11.7818 20.4396H18.1428C18.6018 20.4396 19.0018 20.1276 19.1128 19.6826L19.6128 17.6826C19.7708 17.0516 19.2928 16.4406 18.6428 16.4406Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M21.5 10.4414C21.5 11.2694 20.157 11.9414 18.5 11.9414C16.843 11.9414 15.5 11.2694 15.5 10.4414V8.94141C15.5 8.11341 16.843 7.44141 18.5 7.44141C20.157 7.44141 21.5 8.11341 21.5 8.94141V10.4414Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const LacrosseIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M19.9993 6.68702C20.0115 5.80428 19.8489 4.92784 19.521 4.10818C19.193 3.28852 18.7062 2.54183 18.0885 1.9111C17.4604 1.29541 16.7169 0.809711 15.9007 0.481843C15.0846 0.153975 14.2117 -0.0096183 13.3322 0.000436917H12.8687C12.2731 0.000305575 11.6833 0.117511 11.133 0.345358C10.5826 0.573205 10.0826 0.907231 9.66139 1.32836C9.24018 1.74949 8.90605 2.24947 8.67809 2.79974C8.45013 3.35002 8.33281 3.93981 8.33282 4.53544C8.33288 4.75353 8.29773 4.97021 8.22873 5.1771L7.26799 8.05969C7.06021 8.68346 7.02303 9.35146 7.16032 9.99444L0.585318 16.5694L0.579568 16.5752C0.203951 16.9528 -0.00658097 17.464 -0.00585752 17.9966C-0.00513407 18.5292 0.206785 19.0398 0.583427 19.4164C0.96007 19.793 1.47069 20.0049 2.00331 20.0055C2.53593 20.0062 3.04708 19.7956 3.42465 19.4199L3.4304 19.4142L10.0054 12.8392C10.6484 12.9764 11.3164 12.9393 11.9403 12.7318L14.823 11.771C15.0296 11.7021 15.2459 11.6668 15.4637 11.6666C16.6665 11.6668 17.8201 11.1892 18.6707 10.3389C19.5213 9.48858 19.9993 8.33519 19.9996 7.13244L19.9993 6.68702ZM2.25507 18.2324C2.19036 18.2971 2.10259 18.3335 2.01108 18.3335C1.91957 18.3335 1.83181 18.2971 1.76711 18.2324C1.70241 18.1677 1.66606 18.0799 1.66607 17.9884C1.66608 17.8969 1.70244 17.8091 1.76715 17.7444L7.93315 11.5785C8.00665 11.6669 8.07773 11.7569 8.16024 11.8394C8.24273 11.9219 8.33265 11.993 8.42115 12.0664L2.25507 18.2324ZM18.3327 7.13119C18.3154 7.88681 18.0075 8.60668 17.473 9.14103C16.9384 9.67538 16.2184 9.98308 15.4628 10.0001C15.0663 10.0003 14.6723 10.0644 14.2962 10.1899L11.4137 11.1504C11.0566 11.2695 10.6734 11.2869 10.307 11.2005C9.94057 11.1141 9.60547 10.9273 9.33924 10.6612C9.07301 10.395 8.88618 10.0599 8.79969 9.69353C8.7132 9.32714 8.73047 8.9439 8.84957 8.58677L9.80999 5.7041C9.93534 5.32789 9.99946 4.93399 9.9999 4.53744V4.53652C9.99981 4.15967 10.074 3.78649 10.2182 3.43832C10.3624 3.09014 10.5737 2.77379 10.8402 2.50734C11.1067 2.24089 11.4231 2.02956 11.7713 1.88543C12.1195 1.74131 12.4927 1.6672 12.8696 1.66735L13.3529 1.66677C14.0104 1.65784 14.6631 1.77898 15.2736 2.0232C15.8841 2.26743 16.4403 2.62993 16.9102 3.08985C17.3721 3.5623 17.7357 4.12169 17.9799 4.73564C18.2241 5.34959 18.3441 6.00588 18.3329 6.66652L18.3327 7.13119Z"
            fill="currentColor"
        />
        <path
            d="M16.0753 4.41183L15.8313 4.65583L15.3434 4.16783L15.5873 3.92391C15.7424 3.76739 15.8293 3.5558 15.8288 3.33541C15.8283 3.11503 15.7405 2.90382 15.5847 2.74798C15.4289 2.59215 15.2177 2.50439 14.9973 2.50391C14.7769 2.50343 14.5653 2.59026 14.4088 2.74541L14.1649 2.98941L13.9209 2.74541C13.7643 2.59026 13.5527 2.50343 13.3324 2.50391C13.112 2.50439 12.9008 2.59215 12.7449 2.74798C12.5891 2.90382 12.5013 3.11503 12.5009 3.33541C12.5004 3.5558 12.5872 3.76739 12.7424 3.92391L12.9864 4.16783L12.4984 4.65583L12.2544 4.41183C12.1771 4.33389 12.0852 4.27198 11.984 4.22965C11.8827 4.18732 11.7741 4.1654 11.6644 4.16516C11.5546 4.16492 11.4459 4.18636 11.3445 4.22825C11.243 4.27013 11.1509 4.33164 11.0733 4.40924C10.9957 4.48684 10.9342 4.579 10.8923 4.68044C10.8504 4.78187 10.829 4.89058 10.8292 5.00032C10.8294 5.11006 10.8514 5.21867 10.8937 5.31992C10.936 5.42117 10.9979 5.51307 11.0759 5.59033L11.3199 5.83433L10.2424 6.91183C10.0886 7.0686 10.0029 7.27977 10.0039 7.49941C10.0049 7.71905 10.0927 7.92941 10.248 8.08472C10.4033 8.24004 10.6136 8.32776 10.8333 8.32881C11.0529 8.32986 11.2641 8.24415 11.4209 8.09033L12.4984 7.01283L12.9864 7.50083L11.9089 8.57824C11.8315 8.65562 11.7701 8.74749 11.7282 8.8486C11.6863 8.9497 11.6648 9.05807 11.6648 9.16751C11.6647 9.38852 11.7525 9.60049 11.9088 9.75678C12.0651 9.91307 12.2771 10.0009 12.4981 10.0009C12.7191 10.0009 12.9311 9.9131 13.0874 9.75683L14.1649 8.67924L14.4088 8.92324C14.486 9.00118 14.5779 9.06309 14.6792 9.10542C14.7804 9.14775 14.889 9.16966 14.9988 9.1699C15.1085 9.17014 15.2172 9.14871 15.3187 9.10682C15.4201 9.06494 15.5123 9.00343 15.5899 8.92583C15.6675 8.84823 15.729 8.75607 15.7709 8.65463C15.8127 8.5532 15.8342 8.44449 15.8339 8.33475C15.8337 8.22501 15.8118 8.11639 15.7695 8.01514C15.7271 7.91389 15.6652 7.822 15.5873 7.74474L15.3434 7.50083L15.8313 7.01283L16.0753 7.25683C16.2321 7.41065 16.4432 7.49636 16.6629 7.49531C16.8825 7.49426 17.0929 7.40654 17.2482 7.25122C17.4035 7.09591 17.4912 6.88555 17.4922 6.66591C17.4933 6.44627 17.4075 6.2351 17.2537 6.07833L17.0098 5.83433L17.2537 5.59033C17.4075 5.43355 17.4933 5.22238 17.4922 5.00274C17.4912 4.7831 17.4035 4.57275 17.2482 4.41743C17.0929 4.26211 16.8825 4.17439 16.6629 4.17334C16.4432 4.17229 16.2321 4.258 16.0753 4.41183ZM14.1649 6.32233L13.6769 5.83433L14.1649 5.34633L14.6528 5.83433L14.1649 6.32233Z"
            fill="currentColor"
        />
    </Icon>
);
export const RugbyIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4993 2.49992C18.746 1.67149 22.3276 5.25318 21.4992 10.4998C20.6708 15.7465 15.746 20.6713 10.4994 21.4997C5.25271 22.3281 1.67102 18.7464 2.49944 13.4998C3.32787 8.25312 8.2527 3.32829 13.4993 2.49992Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.46094 12.7109L11.2909 15.5409"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.7109 8.46094L15.5409 11.2909"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.5898 10.5898L13.4098 13.4098"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.8005 2.53711C14.5805 4.65911 15.0515 6.56611 16.2435 7.75711C17.4355 8.94911 19.3415 9.42011 21.4635 9.20011"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.53711 14.8005C4.65911 14.5805 6.56611 15.0515 7.75711 16.2435C8.94911 17.4355 9.42011 19.3415 9.20011 21.4635"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const TableTennisIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.22402 16.7222L7.69702 15.1952C7.32902 14.8272 6.74102 14.8032 6.34402 15.1392L3.28002 17.7312C2.83302 18.1092 2.80502 18.7882 3.21902 19.2012L5.21702 21.2002C5.63102 21.6142 6.31002 21.5852 6.68702 21.1392L9.28002 18.0752C9.61602 17.6782 9.59202 17.0902 9.22402 16.7222Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.86234 6.95025C5.77634 9.67925 6.03134 13.5302 8.46034 15.9592C10.8893 18.3882 14.7403 18.6442 17.4693 16.5572C18.2943 15.9262 19.0313 15.1892 19.6623 14.3642L19.6643 14.3612C21.7503 11.6322 21.4953 7.78125 19.0663 5.35225C17.0943 3.38025 14.1923 2.86825 11.7073 3.85125"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.7207 9.25977L15.1607 17.6998"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.2678 3.23223C12.2441 4.20854 12.2441 5.79145 11.2678 6.76776C10.2915 7.74407 8.70854 7.74407 7.73223 6.76776C6.75592 5.79145 6.75592 4.20854 7.73223 3.23223C8.70854 2.25592 10.2915 2.25592 11.2678 3.23223Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const TennisIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M18 5.30469C16.163 6.95269 15 9.33769 15 11.9997C15 14.6617 16.163 17.0467 18 18.6947"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6 18.6947C7.837 17.0467 9 14.6617 9 11.9997C9 9.33769 7.837 6.95269 6 5.30469"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
export const DefaultIcon = () => (
    <Icon viewBox="0 0 24 24" fill="none" w="24px" h="24px">
        <path
            d="M8.677 8.32345C8.72381 8.37037 8.75006 8.43396 8.75 8.50024C8.74994 8.56652 8.72356 8.63005 8.67666 8.67689C8.62977 8.72372 8.5662 8.75002 8.49992 8.75C8.43364 8.74998 8.37009 8.72364 8.32322 8.67678C8.27636 8.62991 8.25002 8.56636 8.25 8.50008C8.24998 8.4338 8.27628 8.37023 8.32311 8.32334C8.36995 8.27644 8.43349 8.25006 8.49976 8.25C8.56604 8.24994 8.63008 8.27664 8.677 8.32345Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M21.0009 10.1128C19.5186 9.88496 18.0034 10.0094 16.5782 10.4761C15.1529 10.9428 13.8576 11.7386 12.7971 12.7991C11.7366 13.8595 10.9408 15.1548 10.4742 16.5801C10.0075 18.0054 9.88301 19.5205 10.1109 21.0028"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M16 3H8C6.67392 3 5.40215 3.52678 4.46447 4.46447C3.52678 5.40215 3 6.67392 3 8V16C3 17.3261 3.52678 18.5979 4.46447 19.5355C5.40215 20.4732 6.67392 21 8 21H16C17.3261 21 18.5979 20.4732 19.5355 19.5355C20.4732 18.5979 21 17.3261 21 16V8C21 6.67392 20.4732 5.40215 19.5355 4.46447C18.5979 3.52678 17.3261 3 16 3Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Icon>
);
